import { STATS } from "../../data/content";
import { Counter, Reveal } from "../motion/Motion";

export default function StatsBar() {
  return (
    <section data-testid="stats-section" className="relative bg-brand-primary">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid grid-cols-2 divide-x divide-white/10 border-x border-white/10 lg:grid-cols-4">
          {STATS.map((stat, i) => (
            <Reveal key={stat.label} delay={i * 0.08}>
              <div className="flex flex-col gap-2 px-4 py-12 md:px-8">
                <div className="font-heading text-4xl font-extrabold text-white md:text-5xl">
                  {stat.raw ? (
                    stat.value + stat.suffix
                  ) : (
                    <Counter value={stat.value} suffix={stat.suffix} />
                  )}
                </div>
                <div className="h-px w-8 bg-brand-accent" />
                <p className="text-sm leading-snug text-white/60">{stat.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
